// GenKey shows the template key that the server is going to generate.
//
// It does not *decide* the key — the server does, and it is the only one that can:
// it alone knows which keys are taken, and a duplicate key would silently overwrite an
// existing template (SaveDef upserts). This is a preview, so the admin can see the
// identifier their template is about to get instead of guessing.
//
// Locked while editing: the key of a saved template never changes, because the designs
// already quoted point at it.
//
// Keep genSlug() in step with genSlug() in internal/handler/admin/gen_key.go — if they
// drift, the preview lies (harmlessly: the server still wins).
export class GenKey extends HTMLElement {
  connectedCallback(): void {
    if (this.hasAttribute("data-locked")) return;

    const name = this.querySelector<HTMLInputElement>("[data-gen-name]");
    const series = this.querySelector<HTMLSelectElement>("[data-gen-series]");
    const key = this.querySelector<HTMLInputElement>("[data-gen-key]");
    if (!name || !series || !key) return;

    const sync = (): void => {
      key.value = genSlug(series.value, name.value);
    };
    name.addEventListener("input", sync);
    series.addEventListener("change", sync);
    sync();
  }
}

function genSlug(series: string, name: string): string {
  const slug = (s: string): string =>
    s
      .trim()
      .toLowerCase()
      .normalize("NFD")
      .replace(/[̀-ͯ]/g, "") // tildes
      .replace(/[^a-z0-9]+/g, "_")
      .replace(/^_+|_+$/g, "");

  const n = slug(name);
  const s = slug(series);
  if (!n && !s) return "plantilla";
  if (!n) return s;
  if (!s) return n;
  return `${s}_${n}`;
}
